// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-18T17:29:05.352Z
// Property: The Lynx (ID: 6767906449162935)
// Collections: 75 amenities, 9 floorplans (live), 59 photos, 2 POIs, 9 reviews, 3 virtual tours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162273",
  "multihub_property_id": "6767906449162935",
  "property_external_id": "4981189",
  "property_zillow_url": "https://www.zillow.com/apartments/san-antonio-tx/amberton-garden/5Xq2v6/",
  "property_apartments_url": "https://www.apartments.com/the-lynx-san-antonio-tx/1mds7z4",
  "property_google_business_url": null,
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": null,
  "property_pm_software": null,
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "the-lynx",
  "property_name": "The Lynx",
  "property_website_url": "https://www.thelynxliving.com/",
  "property_domain": null,
  "property_address": "6000 Randolph Blvd",
  "property_full_address": "6000 Randolph Blvd",
  "property_address_1": "6000 Randolph Blvd",
  "property_address_2": null,
  "property_address_city": "San Antonio",
  "property_address_state": "TX",
  "property_address_zip_full": "78233-5734",
  "property_address_zip": "78233",
  "property_address_country": "US",
  "property_address_county": "Bexar County",
  "property_neighborhood_address": "Royal Ridge",
  "property_address_latitude": "29.540621",
  "property_address_longitude": "-98.369124",
  "property_email": "lynx@alapts.com",
  "property_phone": "(210) 655-1806",
  "property_call_tracking_phone": null,
  "property_company_name": "Repli Sandbox",
  "property_company_url": "testurl.com",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Discover your ideal living space at The Lynx in San Antonio, Texas. Choose from spacious one, two, or three-bedroom floor plans, and enjoy top-notch amenities like a fitness center, roof terrace, and gameroom. Find your new home today—browse our availability or schedule a tour to visit our community!",
  "property_long_description": "**Discover Luxury Living at The Lynx in San Antonio, Texas**\n\nWelcome to The Lynx, where vibrant living meets unparalleled comfort in the heart of San Antonio. Our thoughtfully designed apartment community offers a variety of floor plans, including one, two, and three-bedroom apartments, ensuring you find the perfect space that suits your lifestyle. Enjoy modern interiors with plenty of natural light and space to relax and entertain.\n\nAt The Lynx, we prioritize your comfort and convenience with an array of luxurious amenities. Stay active and healthy in our fully equipped fitness center, entertain friends in our elegant clubhouse, or unwind on our stunning roof terrace featuring breathtaking views. Our pet-friendly community includes a pet washing station so your furry friends can enjoy the comforts of home just as much as you do.\n\nExperience a lifestyle of leisure with access to our gameroom, media center, and sundeck, where you can soak up the Texas sun. Our community is gated for your privacy and security, and we offer 24-hour access for your convenience. With convenient public transportation options, bicycle storage, and walking/biking trails right outside, exploring the city has never been easier.\n\nAt The Lynx, our dedicated staff, including an on-site property manager and maintenance team, are here to ensure your living experience is exceptional every day. \n\nDon’t miss out on the opportunity to call The Lynx home! Find your new home today—browse our availability or schedule a tour to visit our community and see firsthand what makes us a standout choice in San Antonio.",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfddf-be44-75c9-8ee3-3c539324cff5.webp",
  "property_featured_image_media": {
    "alt_text": "Modern kitchen with granite countertops and stainless steel appliances.",
    "public_id": "019cfddf-be44-75c9-8ee3-3c539324cff5",
    "storage_key": "property/6767906449162935/019cfddf-be44-75c9-8ee3-3c539324cff5.webp",
    "width": 1240,
    "height": 828
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "552",
  "property_year_built": "1984",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "93.47826086956522",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": null,
  "property_allows_cats": null,
  "property_allows_dogs": null,
  "property_upfront_pet_fee": null,
  "property_pet_deposit": null,
  "property_monthly_pet_rent": null,
  "property_max_pets": null,
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": null,
  "property_pet_policy_description": null,
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": null,
  "property_apply_now_url": null,
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfddf-b207-72b9-8feb-69c06f3c4f7b.webp",
  "property_primary_logo_media": {
    "alt_text": "American Landmark logo.",
    "public_id": "019cfddf-b207-72b9-8feb-69c06f3c4f7b",
    "storage_key": "property/6767906449162935/019cfddf-b207-72b9-8feb-69c06f3c4f7b.webp",
    "width": 325,
    "height": 147
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfddf-b207-72b9-8feb-69c06f3c4f7b.webp",
  "property_secondary_logo_media": {
    "alt_text": "American Landmark logo.",
    "public_id": "019cfddf-b207-72b9-8feb-69c06f3c4f7b",
    "storage_key": "property/6767906449162935/019cfddf-b207-72b9-8feb-69c06f3c4f7b.webp",
    "width": 325,
    "height": 147
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": null,
  "property_mono_white_logo_media": null,
  "property_mono_black_logo": null,
  "property_mono_black_logo_media": null,
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162273/019cfdd9-c8a4-71d3-8bff-111ee22aee5d.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162273/019d2713-d4f5-701a-91f4-9c4e82dc6c6b.webp",
  "property_company_logo_media": {
    "alt_text": "Repli logo",
    "public_id": "019d2713-d4f5-701a-91f4-9c4e82dc6c6b",
    "storage_key": "company/5767906449162273/019d2713-d4f5-701a-91f4-9c4e82dc6c6b.webp",
    "width": 640,
    "height": 314
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162273/019d2705-ea93-721c-8d4f-e2d2a439a839.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Repli logo",
    "public_id": "019d2705-ea93-721c-8d4f-e2d2a439a839",
    "storage_key": "company/5767906449162273/019d2705-ea93-721c-8d4f-e2d2a439a839.webp",
    "width": 640,
    "height": 314
  },
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": null,
  "property_secondary_color": null,
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "400 - 1125",
  "property_sqft_min": "400",
  "property_sqft_max": "1125",
  "property_price_range": "830.16 - 1579.66",
  "property_price_min": "830.16",
  "property_price_max": "1579.66",
  "property_available_units": 36,
  "property_facebook_url": null,
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": null,
  "property_youtube_url": null,
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": null,
  "property_home_amenities_blurb": null,
  "property_home_floorplans_blurb": null,
  "property_home_gallery_blurb": null,
  "property_home_neighborhood_blurb": "Discover the vibrant neighborhood surrounding The Lynx in San Antonio, Texas! With spacious one, two, and three-bedroom floor plans, our community offers the perfect home. Explore local favorites and points of interest—see what's around and enrich your living experience today! Your ideal lifestyle awaits at The Lynx.",
  "property_home_reviews_blurb": null,
  "property_neighborhood_blurb": "Filled with pleasant neighbors and well-kept residential streets, Royal Ridge is an affordable suburb of San Antonio. Nestled along Interstate 35, residents of this neighborhood have easy access to nearby neighborhoods, including Downtown, located just 15 miles southwest of town. Paved sidewalks and tree-lined streets give this neighborhood a safe, family-friendly vibe.\n\t\t\t\t\tResidents of Royal Ridge are near several shopping centers, Woodcrest Park, Morgan’s Wonderland, and the San Antonio International Airport. For all of your shopping needs, check out the Forum at Olympia Parkway, located just a few miles up Interstate 35! This open air shopping center features restaurants, furniture stores, beauty services, apparel shops, and more. Renters have the choice between updated apartments and charming homes in this convenient suburb.\n\t\t\t\t\t\n\t\t\t\t\t\n\t\t\t\t\t\tLearn more about living in Royal Ridge",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "Discover The Lynx in San Antonio, Texas, where modern living meets unmatched amenities. Choose from spacious one, two, or three-bedroom floor plans and enjoy exclusive features like a fitness center, roof terrace, and a gameroom. Explore our amazing community amenities and apartment features today!",
  "property_applynow_blurb": "Discover your perfect home at The Lynx in San Antonio, Texas! Choose from spacious one, two, or three-bedroom floor plans while enjoying top-notch amenities like a fitness center, rooftop terrace, and gameroom. Don’t wait—apply online today and experience the lifestyle you deserve! ",
  "property_contactus_blurb": "Discover your perfect home at The Lynx in beautiful San Antonio, Texas! Our community features a variety of thoughtfully designed floor plans, including one, two, and three-bedroom options. Have questions? Contact our leasing team today to explore all that The Lynx has to offer! Your new lifestyle awaits.",
  "property_faqs_blurb": "Welcome to The Lynx in San Antonio, Texas! Explore our diverse floor plans, including one-, two-, and three-bedroom apartments. Have questions? Browse our FAQs page to find answers about our community and discover the perfect home that fits your lifestyle. Your sanctuary awaits at The Lynx!",
  "property_floorplans_blurb": "Discover your ideal living space at The Lynx in San Antonio, Texas! With thoughtfully designed one, two, and three-bedroom floor plans, we have something for everyone. Explore all our available apartment homes today and find the perfect floor plan that suits your lifestyle. Browse now!",
  "property_gallery_blurb": "Discover your perfect home at The Lynx in San Antonio, Texas! Choose from our spacious one, two, or three-bedroom floor plans, and enjoy top-notch amenities including a fitness center, rooftop terrace, and gameroom. Picture yourself living here—browse our photo gallery today and envision your new lifestyle!",
  "property_interactivemap_blurb": "Discover your ideal home at The Lynx in San Antonio, Texas! Choose from our spacious one, two, or three-bedroom floor plans. Enjoy exceptional amenities like a fitness center, rooftop terrace, and clubhouse. Navigate your new community effortlessly using our interactive map to explore available apartments and pricing!",
  "property_pets_blurb": null,
  "property_referafriend_blurb": "Discover your perfect home at The Lynx in San Antonio, Texas! Choose from our thoughtfully designed one, two, and three-bedroom floor plans. Enjoy the vibrant community and fantastic amenities. Great friends make great neighbors—refer a friend to our welcoming apartment community today! Explore all our options now!",
  "property_residentaccess_blurb": "Welcome to The Lynx in San Antonio, Texas! Explore our diverse floor plans, featuring one, two, and three-bedroom apartments. Enjoy seamless living with our resident access portal—pay rent, schedule maintenance, and manage your home effortlessly. Log in today to experience the convenience of modern apartment living!",
  "property_reviews_blurb": null,
  "property_created_at": "1752257814964",
  "property_scheduletour_blurb": "Discover your perfect home at The Lynx in San Antonio, Texas, with thoughtfully designed one, two, and three-bedroom floor plans. Schedule a tour today and experience our vibrant community. Curious about resident experiences? See what our residents have to say about life at The Lynx! Your ideal apartment awaits!",
  "property_thankyou_blurb": "Thank you for your interest in The Lynx, San Antonio's premier apartment community! Explore our spacious one, two, and three-bedroom floor plans tailored to your lifestyle. A member of our team will reach out shortly to assist you in finding your perfect home. Stay tuned for exciting updates!",
  "property_virtualtours_blurb": "Discover your ideal home at The Lynx in San Antonio, Texas! Choose from our spacious one, two, or three-bedroom floor plans designed for comfort and style. Take a virtual tour of our vibrant community and explore the perfect apartment for rent today! Experience luxury living—schedule your tour now!",
  "property_copyright": "2025 All Rights Reserved. The Lynx",
  "property_seo_title_home": "The Lynx | Apartments in San Antonio, Texas",
  "property_seo_description_home": "Discover your perfect home at The Lynx, a premier apartment community in San Antonio, Texas. Choose from thoughtfully designed one, two, or three-bedroom floor plans that fit your lifestyle. Enjoy resort-style amenities including a fitness center, clubhouse, roof terrace, and pet washing station, all within a gated community. With on-site maintenance, a business center, and 24-hour access, convenience is at your fingertips. Explore nearby walking and biking trails and relax in our picnic area or gameroom. Find your new home today at The Lynx!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 3 Apartments in San Antonio, Texas",
  "property_seo_description_floorplans": "Discover your ideal living space at The Lynx in San Antonio, Texas! Our thoughtfully designed floor plans feature one, two, and three-bedroom options to suit your lifestyle. Explore our diverse layouts and amenities by browsing all available apartment homes. Your perfect floor plan awaits!",
  "property_seo_title_amenities": "Amenities | San Antonio, Texas Apartments for Rent",
  "property_seo_description_amenities": "Discover The Lynx in San Antonio, Texas—your ideal apartment community featuring spacious one, two, and three-bedroom floor plans. Enjoy top-tier amenities like a state-of-the-art fitness center, inviting roof terrace, and a vibrant clubhouse. With on-site maintenance, concierge services, and secure gated access, your comfort and convenience are our priority. Relax in our media center or picnic area, and take advantage of our pet washing station and EV charging facilities. Explore our amazing community amenities and discover your new home today!",
  "property_seo_title_gallery": "Gallery | Apartments in San Antonio, Texas",
  "property_seo_description_gallery": "Explore The Lynx, an exquisite apartment community in San Antonio, Texas, where modern living meets luxury amenities. Browse our stunning photo gallery showcasing one, two, and three-bedroom floor plans. Enjoy top-notch amenities like a fully-equipped fitness center, inviting clubhouse, scenic roof terrace, and a pet washing station. With 24-hour access, on-site maintenance, and convenient EV charging, you’ll have everything you need right at your doorstep. Picture yourself living here and discover your new lifestyle today!",
  "property_seo_title_virtualtours": "Virtual Tours | The Lynx Apartments",
  "property_seo_description_virtualtours": "Explore your new home at The Lynx in San Antonio, Texas! Our vibrant apartment community offers stunning one, two, and three-bedroom floor plans designed for your lifestyle. Ready to find your perfect fit? Take a virtual tour of our apartments for rent today and discover the comfort and convenience that awaits you!",
  "property_seo_title_interactivemap": "Interactive Map | The Lynx Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at The Lynx in beautiful San Antonio, Texas! Choose from spacious one, two, or three-bedroom floor plans and enjoy exceptional amenities including a fitness center, rooftop terrace, and vibrant clubhouse. Explore our interactive community map to find available apartments, view pricing, and envision your new lifestyle today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in San Antonio, Texas",
  "property_seo_description_neighborhood": "Discover the vibrant neighborhood surrounding The Lynx in San Antonio, Texas! Explore our one, two, and three-bedroom apartment floor plans as you uncover local favorites and nearby points of interest. See what's around our community and join us today for a life filled with convenience and adventure!",
  "property_seo_title_contact": "Contact Us | The Lynx",
  "property_seo_description_contact": "Discover your new home at The Lynx in San Antonio, Texas! Our stunning one, two, and three-bedroom floor plans cater to every lifestyle. Have questions? Contact our leasing team today to learn more about our vibrant community and find the perfect apartment for you!",
  "property_seo_title_faqs": "FAQs | Apartments in San Antonio, Texas",
  "property_seo_description_faqs": "Discover everything you need to know about The Lynx, your premier apartment community in San Antonio, Texas! With a variety of floor plans from one to three bedrooms, top-notch amenities like a fitness center, rooftop terrace, and clubhouse, we have it all. Have questions? Browse our FAQs page for insightful answers about our gated community, pet amenities, and more. Join us at The Lynx—where luxury and convenience meet!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in San Antonio, Texas",
  "property_seo_description_reviews": "Discover the vibrant living experience at The Lynx in San Antonio, Texas! Explore our spacious one, two, and three-bedroom floor plans designed for comfort and convenience. Our top-notch amenities include a fitness center, clubhouse, roof terrace, and gameroom, along with a pet washing station and EV charging. With an on-site property manager, 24-hour access, and gated security, The Lynx is the perfect place to call home. Don’t just take our word for it—see what our residents have to say about living in this exceptional community!",
  "property_seo_title_applynow": "Apply Now | Apartments in San Antonio, Texas",
  "property_seo_description_applynow": "Discover your perfect home at The Lynx in San Antonio, Texas! Explore spacious one, two, and three-bedroom floor plans designed for modern living. Enjoy unparalleled amenities, from a state-of-the-art fitness center and rooftop terrace to a clubhouse and pet washing station. Our gated community offers 24-hour access, on-site maintenance, and convenient EV charging! Experience a vibrant lifestyle with walking trails, a gameroom, and picnic areas right outside your door. Ready to elevate your living experience? **Apply now and lease online today!**",
  "property_seo_title_residentaccess": "Resident Access | The Lynx",
  "property_seo_description_residentaccess": "\"Welcome to The Lynx in San Antonio, TX! Access your resident portal to easily pay rent, schedule maintenance, and manage your apartment needs. Enjoy seamless living with just a few clicks!\"",
  "property_seo_title_referafriend": "Refer A Friend | The Lynx",
  "property_seo_description_referafriend": "\"Refer a friend to The Lynx in San Antonio, TX! Great friends make great neighbors, and when you bring them to our vibrant apartment community, you'll enjoy exclusive rewards. Discover the perfect blend of comfort and connection—refer a friend today and enhance your living experience!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | The Lynx",
  "property_seo_description_scheduletour": "\"Discover your new home at The Lynx in vibrant San Antonio, Texas! Enjoy upscale amenities and a welcoming community. Schedule a tour today to explore our beautiful apartments and see why our residents love calling The Lynx home!\"",
  "property_seo_title_privacy": "Privacy Policy | The Lynx",
  "property_seo_description_privacy": "\"Discover peace of mind at The Lynx in San Antonio, Texas. Our privacy policy ensures your information is secure while you enjoy our vibrant apartment community. View our privacy policy to learn more!\"",
  "property_seo_title_accessibility": "Website Accessibility | The Lynx",
  "property_seo_description_accessibility": "\"Discover The Lynx, your ideal San Antonio apartment community committed to digital inclusion. Explore our Accessibility Statement to learn how we ensure everyone can enjoy our vibrant living spaces. Join us in creating a welcoming home for all! 🌟\"",
  "property_seo_title_sitemap": "Sitemap | The Lynx",
  "property_seo_description_sitemap": "\"Explore The Lynx, your premier apartment community in San Antonio, Texas! Navigate our sitemap for an organized overview of amenities, floor plans, and local attractions. Discover your perfect home today!\"",
  "property_seo_title_thankyou": "Thank You | The Lynx",
  "property_seo_description_thankyou": "Thank you for reaching out to The Lynx in vibrant San Antonio, Texas! Your inquiry is important to us, and a dedicated member of our team will be in touch shortly to assist with your apartment needs. Stay tuned for updates and exciting opportunities to call The Lynx your new home!",
  "property_seo_title_pets": null,
  "property_seo_description_pets": null,
  "property_updated_at": "1784584424942",
  "amenities": [
    {
      "id": "ec_bf5cdb39b205cae1dda8129e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "Controlled Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_35841de04d358ceaaaa452b5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "Laundry Facilities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_83be5c147031a786a634e49b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "Property Manager on Site",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4f2004e1f10d033dd0e3a4c0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "Laundry Service",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_64794a239866deaf5979d64f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "Pet Play Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3aecdece3e6c325a1324bcc6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "Recycling",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_06d71183ade356119bb4902a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "Maintenance on site",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b827bf2c0a79ed5e60f4f503",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "Online Services",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_edeeb871bcdb8be1d08ff0e0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "Public Transportation",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b4d5465b333cef3600239993",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e610881cf8cd7271aaa89c86",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "Walk-Up",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8f2205d1a15a9f6a3bb9abef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "Gated",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_14b36990a1c5c116a88df270",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5f38469a0d96225d78571a55",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2516f1897407983d8bfbb099",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_95df8668da7e6a1d64662424",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "Basketball Court",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4d1ea58f32ec52719f4bd4e6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "Volleyball Court",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_37ca716be0e5853739aaf3c0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "*In Select Homes",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e0dfc107d38bbe7b1d200ac1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "2 Faux Wood Blinds",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_07bf6ec9d9bd6cfe69b9e10b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "9 Foot Ceilings*",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_caa8e2079dd3570fa36ba1ed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "American Landmark 360 Resident Program",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_612511e00063525133cb3f48",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "Bark Park for your Furry Friends",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_73120a5bc6e9b814d19ab8d7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "Built-In Bookshelves*",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0a840e80209b1b2a8e8409a4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "Controlled Access Community",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b3dd50e178f899b0b0c5ef1d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "Convenient 24/7 Online Resident Services",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_712d3dd195ad8d7895f06eb5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "Decorative Tile Backsplash",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_304345c99a855f8b9c5fa7ab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "Designer Cabinetry",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d743201382e76ba04da932d7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "Fireplaces",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_71b86e5d86efc5617aa701a9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "Granite Countertops w/Undermount Sink",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ccc5889f021473184604fe49",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "In-Home Washer & Dryer",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bb51b4307c897f8d26d29b97",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "Outdoor Kitchen-Style Grill Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c0597902f0e8349dc809e4f1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "Resident Concierge Package System",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0bb2eaa8e056faebfe5aa9ab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "Sunrooms",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7aab335f3060841765c13920",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "USB Outlets**",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dc3d36d9cac352ca285cb3a1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9a6e85bcb7af35ecd1abeab6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2b6c5264ac187d0edfd9a904",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "Fireplace",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_eed01a7e250374e7b9336001",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "Storage Space",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_603ce2f431b11dbd3c1a25c9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cde63f0b33299a8b0e10cd92",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "Heating",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ab8584fc0c41fbcf296fa175",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3ba4c143fe89555d40cfa79b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "High Speed Internet Access",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3d28f9eb9c83475f62a1e5d4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "Sprinkler System",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1024fa346c82e30fcb1e5464",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "Tub/Shower",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_157737c48082760240d4a6bc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "Wi-Fi",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d683391584d8081d236501f3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "Framed Mirrors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_053d9ddfbf20cb4ca30aeadf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "Smoke Free",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_70463d2109467302ba048c5e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "Wheelchair Accessible (Rooms)",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6041728996176232cb503260",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e52f39c1ca542e4bf7439d63",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a9d4efd1f7a4fab5c89280c0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b3a456a9c7ddbd418db5976f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_56a8070c2059434ba682c8d2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "Ice Maker",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_810af1492a3b13cd72020cb9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cd1dffc7172c53b411593be3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "Oven",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7e39c6f9d8e78795b57dbcb9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_73a41a7ddb6c32535d65b2fe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "Range",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3a86ed276ec3c503292f8126",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "Freezer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8ae32a885dc2866168d88a04",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "Pantry",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ab3283830934dae762ed01bb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "Tile Floors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6f9a6d6e339be99c08432012",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "Hardwood Floors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4514a19653565192a94fded9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "Vaulted Ceiling",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f3571a41a4596f840eef652d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "Sunroom",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1fe10212f513db6280a65c68",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "Views",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ffbdc1feaf40598368904609",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "Walk-In Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8b2c608655df4a9ac877c7d8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "Carpet",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f8205ee4d1a17f6ae0fdd8fe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "Built-In Bookshelves",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_895592559c3b385347ea3c8b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "Dining Room",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6c8d35138bafb2aba4fb7c2b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "Double Pane Windows",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5121ebf8cda817387e80eb9c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "Linen Closet",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_58a8abe9451eff2021e57f1e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "Vinyl Flooring",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_372a37f1e7d62a8b9016b5a1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "Window Coverings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7943addbacf3b7bd8422a631",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6740f594ad55c5790bbf855b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "Patio",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8099aa92dd20027cd5570d8a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "external_id": "false",
      "title": "Porch",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_915c8a9159ba5ef0301b205a",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfdde-bf2b-70fd-89e9-8808ce0b8635.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and a breakfast bar.",
        "public_id": "019cfdde-bf2b-70fd-89e9-8808ce0b8635",
        "storage_key": "property/6767906449162935/019cfdde-bf2b-70fd-89e9-8808ce0b8635.webp",
        "width": 2000,
        "height": 1335
      },
      "title": "Apartment",
      "description": "Experience the perfect blend of style and functionality in this modern kitchen, featuring sleek granite countertops, a full suite of stainless steel appliances, and a convenient breakfast bar for casual dining.",
      "link": "false",
      "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and a breakfast bar.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/n5NHjpHw6AG5I0LTT1BAqFtS4EyXzNvz9OpqjCfMSXo/102/image.jpg"
    },
    {
      "id": "ec_4cf3c6e73e0989e906c476b3",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfdde-bf2b-70fd-89e9-8808ce0b8635.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and a breakfast bar.",
        "public_id": "019cfdde-bf2b-70fd-89e9-8808ce0b8635",
        "storage_key": "property/6767906449162935/019cfdde-bf2b-70fd-89e9-8808ce0b8635.webp",
        "width": 2000,
        "height": 1335
      },
      "title": "Apartment",
      "description": "Experience the perfect blend of style and functionality in this modern kitchen, featuring sleek granite countertops, a full suite of stainless steel appliances, and a convenient breakfast bar for casual dining.",
      "link": "false",
      "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and a breakfast bar.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/n5NHjpHw6AG5I0LTT1BAqFtS4EyXzNvz9OpqjCfMSXo/102/image.jpg"
    },
    {
      "id": "ec_b22864da93f7bcc9beda6149",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfdde-c276-753b-8c4a-cfc3d38cb2e4.webp",
      "image_media": {
        "alt_text": "Living room and dining area in apartment",
        "public_id": "019cfdde-c276-753b-8c4a-cfc3d38cb2e4",
        "storage_key": "property/6767906449162935/019cfdde-c276-753b-8c4a-cfc3d38cb2e4.webp",
        "width": 2048,
        "height": 1152
      },
      "title": "Apartment",
      "description": "Spacious living and dining area with modern furniture and decor. Perfect for entertaining guests.",
      "link": "false",
      "alt_text": "Living room and dining area in apartment",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/pJxUKeq8vLNJjQuLWy1z3DwAtQ78R48Dc4I4RguFvU8/102/image.jpg"
    },
    {
      "id": "ec_526c3210bc528de3aefd32b6",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfddf-a41f-76a8-bd3d-eb70417eb42f.webp",
      "image_media": {
        "alt_text": "Modern dining and living room with a sectional sofa, coffee table, and dining table with chairs.",
        "public_id": "019cfddf-a41f-76a8-bd3d-eb70417eb42f",
        "storage_key": "property/6767906449162935/019cfddf-a41f-76a8-bd3d-eb70417eb42f.webp",
        "width": 2048,
        "height": 1152
      },
      "title": "Apartment",
      "description": "Spacious and stylish dining and living room featuring a comfortable sectional sofa, elegant coffee table, and a modern dining set, perfect for relaxing and entertaining.",
      "link": "false",
      "alt_text": "Modern dining and living room with a sectional sofa, coffee table, and dining table with chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/ssCAnK5dJ89uheYgo3WLsNYQx2jVx6d6RXKOsdaFGxM/115/image.jpg"
    },
    {
      "id": "ec_83ecedad397d6295cfbf4214",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019d4f39-18e6-77aa-837c-cf58b8f0ab89.webp",
      "image_media": {
        "alt_text": "Apartment building with a large swimming pool and lounge chairs.",
        "public_id": "019d4f39-18e6-77aa-837c-cf58b8f0ab89",
        "storage_key": "property/6767906449162935/019d4f39-18e6-77aa-837c-cf58b8f0ab89.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling swimming pool, surrounded by lush landscaping and comfortable lounge seating. Perfect for sunny days!",
      "link": "false",
      "alt_text": "Apartment building with a large swimming pool and lounge chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/vtnGET97Gb_lL4nGc2yytn3DkZh-OVHQ_IqCvHlKZMM/102/image.jpg"
    },
    {
      "id": "ec_8891d574d59546f88952d50a",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfdde-cb09-762b-ac70-cfcfbbd80c71.webp",
      "image_media": {
        "alt_text": "Gym with weight racks, barbells, benches, and dumbbells.",
        "public_id": "019cfdde-cb09-762b-ac70-cfcfbbd80c71",
        "storage_key": "property/6767906449162935/019cfdde-cb09-762b-ac70-cfcfbbd80c71.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "State-of-the-art fitness center with weight racks, barbells, benches, and dumbbells for a complete workout.",
      "link": "false",
      "alt_text": "Gym with weight racks, barbells, benches, and dumbbells.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/8s9TpW5jERhf4K3t-3htYqUAk5cv8XUD439R1POwtfc/119/image.jpg"
    },
    {
      "id": "ec_e5a2dd348be02ea420bef104",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfdde-ca45-774e-a051-75f7b8f70ce8.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, dresser, and desk.",
        "public_id": "019cfdde-ca45-774e-a051-75f7b8f70ce8",
        "storage_key": "property/6767906449162935/019cfdde-ca45-774e-a051-75f7b8f70ce8.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "A beautifully appointed bedroom featuring a queen-size bed, a decorative dresser, and a desk with a comfortable chair, perfect for unwinding or working.",
      "link": "false",
      "alt_text": "Bedroom with a queen-size bed, dresser, and desk.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/LA2Tp7DzH_a-TnTPI64OvTmstqAJgMiM6EK4RUOnh7I/102/image.jpg"
    },
    {
      "id": "ec_3e6d988852ebc6f94fa38b41",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfdde-d129-751a-bce8-9e934e22e9a2.webp",
      "image_media": {
        "alt_text": "Swimming pool with lounge chairs and trees surrounding apartment buildings.",
        "public_id": "019cfdde-d129-751a-bce8-9e934e22e9a2",
        "storage_key": "property/6767906449162935/019cfdde-d129-751a-bce8-9e934e22e9a2.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Relax by the sparkling swimming pool, featuring comfortable lounge chairs and lush landscaping, perfect for unwinding after a long day.",
      "link": "false",
      "alt_text": "Swimming pool with lounge chairs and trees surrounding apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/MpuxN6ccyXksJRRcQKVA6f3JFkUET7jt5pFg61E9W2E/119/image.jpg"
    },
    {
      "id": "ec_819bf42f9933263022b41a86",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfdde-cde0-747d-a746-354e3090d1de.webp",
      "image_media": {
        "alt_text": "Dog park with agility equipment, benches, and apartment buildings in the background.",
        "public_id": "019cfdde-cde0-747d-a746-354e3090d1de",
        "storage_key": "property/6767906449162935/019cfdde-cde0-747d-a746-354e3090d1de.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy our dedicated dog park, complete with agility obstacles and comfortable seating for you and your furry friends.",
      "link": "false",
      "alt_text": "Dog park with agility equipment, benches, and apartment buildings in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/zhvDotNOT4B7ONgvgSFeuNuAPXB5ap6JyKBQj6MBNFA/102/image.jpg"
    },
    {
      "id": "ec_96c9043f563fd3a660a55989",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfdde-d6bf-7092-8787-e1e78a9d1b91.webp",
      "image_media": {
        "alt_text": "Dog park with agility equipment including tunnels, jumps, and benches.",
        "public_id": "019cfdde-d6bf-7092-8787-e1e78a9d1b91",
        "storage_key": "property/6767906449162935/019cfdde-d6bf-7092-8787-e1e78a9d1b91.webp",
        "width": 2000,
        "height": 1498
      },
      "title": "Community",
      "description": "Enjoy our on-site dog park, complete with agility equipment and plenty of space for your furry friends to play and socialize.",
      "link": "false",
      "alt_text": "Dog park with agility equipment including tunnels, jumps, and benches.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/5BDbp7JFZMomLMUiRfxoE0tcr4zJR0Z7fLYn-bTk0h8/119/image.jpg"
    },
    {
      "id": "ec_29f2ede06311e1a9ed01f694",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfdde-da5c-75e8-b629-c72065c43287.webp",
      "image_media": {
        "alt_text": "Modern bathroom with vanity, toilet, and shower.",
        "public_id": "019cfdde-da5c-75e8-b629-c72065c43287",
        "storage_key": "property/6767906449162935/019cfdde-da5c-75e8-b629-c72065c43287.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Experience comfort and style in our well-appointed bathrooms, featuring a spacious vanity, modern fixtures, and a relaxing shower/tub combo.",
      "link": "false",
      "alt_text": "Modern bathroom with vanity, toilet, and shower.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/nJ9rvzniQpA4Nt51oN-f02_1eCmu67lABw5UZ8vK8XQ/102/image.jpg"
    },
    {
      "id": "ec_3583199c5a9a5159c45572c3",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfdde-dc09-74ca-adf5-86d94afe57d0.webp",
      "image_media": {
        "alt_text": "Secure package lockers with \"The Lynx\" branding.",
        "public_id": "019cfdde-dc09-74ca-adf5-86d94afe57d0",
        "storage_key": "property/6767906449162935/019cfdde-dc09-74ca-adf5-86d94afe57d0.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Modern, secure package lockers labeled \"The Lynx\" offer residents a convenient and safe way to receive deliveries.",
      "link": "false",
      "alt_text": "Secure package lockers with \"The Lynx\" branding.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/AfuBk0SnEBA0nfzBUNZCcExoXy5pjhrDthuwiNT4wDw/119/image.jpg"
    },
    {
      "id": "ec_828ae311d2736befef4291c4",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfdde-e212-75b0-8472-2a6d179d75a2.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with hanging rods and shelves",
        "public_id": "019cfdde-e212-75b0-8472-2a6d179d75a2",
        "storage_key": "property/6767906449162935/019cfdde-e212-75b0-8472-2a6d179d75a2.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet featuring ample shelving and hanging space, perfect for organizing your wardrobe.",
      "link": "false",
      "alt_text": "Empty walk-in closet with hanging rods and shelves",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/L39S05F9_42f4QTOB3fC_7HexoWdyQefrYunbWAB4gU/102/image.jpg"
    },
    {
      "id": "ec_03e11adec28d58648f6f5d2d",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfdde-e7c7-75e0-a7b0-f2edd73bf256.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and palm trees in front of apartment buildings.",
        "public_id": "019cfdde-e7c7-75e0-a7b0-f2edd73bf256",
        "storage_key": "property/6767906449162935/019cfdde-e7c7-75e0-a7b0-f2edd73bf256.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Relax and unwind by the sparkling outdoor swimming pool, complete with comfortable lounge chairs and lush palm trees, offering a perfect oasis for residents.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and palm trees in front of apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/zAmnHHuJnTn8qCmsKw7kbCPn7n3SqqMhUsKq6Re_1Hs/119/image.jpg"
    },
    {
      "id": "ec_02b1dd952198c374ef78d5ce",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfdde-e89e-7188-ad13-5c789280ca94.webp",
      "image_media": {
        "alt_text": "Modern living room with a curved sofa, two accent chairs, a dark blue media console with a TV, and a wet bar.",
        "public_id": "019cfdde-e89e-7188-ad13-5c789280ca94",
        "storage_key": "property/6767906449162935/019cfdde-e89e-7188-ad13-5c789280ca94.webp",
        "width": 2000,
        "height": 1337
      },
      "title": "Apartment",
      "description": "Stylish living area featuring a curved sofa, plush armchairs, and a sleek media console. Includes a convenient wet bar for entertaining.",
      "link": "false",
      "alt_text": "Modern living room with a curved sofa, two accent chairs, a dark blue media console with a TV, and a wet bar.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/89_-Q2VXBkOlnU9qigmI-Qbz7g4iXKplRpMZyCzF12k/102/image.jpg"
    },
    {
      "id": "ec_5033c1ca9276463b39b1546d",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfdde-e77f-7793-85c8-dddabff24e5d.webp",
      "image_media": {
        "alt_text": "Modern living room with a curved sofa, accent chairs, and a built-in bar.",
        "public_id": "019cfdde-e77f-7793-85c8-dddabff24e5d",
        "storage_key": "property/6767906449162935/019cfdde-e77f-7793-85c8-dddabff24e5d.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this elegantly appointed living area, perfect for relaxation and entertaining. Features a chic seating arrangement and a convenient wet bar.",
      "link": "false",
      "alt_text": "Modern living room with a curved sofa, accent chairs, and a built-in bar.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/qxH2Sb4pZazCCCFAq61vNjMd3BFh1lWc8SbtC5eF_Vs/119/image.jpg"
    },
    {
      "id": "ec_222d69c1c7282367d6cad5f5",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfdde-ef7a-71f0-92fb-3b98ddc9f692.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, ellipticals, weight machines, and a tire.",
        "public_id": "019cfdde-ef7a-71f0-92fb-3b98ddc9f692",
        "storage_key": "property/6767906449162935/019cfdde-ef7a-71f0-92fb-3b98ddc9f692.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with cardio machines, weight training equipment, and functional training tools.",
      "link": "false",
      "alt_text": "Fitness center with treadmills, ellipticals, weight machines, and a tire.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/wxDWFYuhHybr2ShxUPXz0ciQHlo8rhJTcizDCshmV20/102/image.jpg"
    },
    {
      "id": "ec_ff66e8eeb68b5126dad9a912",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfdde-f5fa-75cd-ba80-a7e784ccf88b.webp",
      "image_media": {
        "alt_text": "Modern stainless steel kitchen with granite countertops and decorative artwork.",
        "public_id": "019cfdde-f5fa-75cd-ba80-a7e784ccf88b",
        "storage_key": "property/6767906449162935/019cfdde-f5fa-75cd-ba80-a7e784ccf88b.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Stylish kitchen featuring stainless steel appliances, granite countertops, and sleek cabinetry. Perfect for preparing meals and entertaining.",
      "link": "false",
      "alt_text": "Modern stainless steel kitchen with granite countertops and decorative artwork.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/zsNykThMItlzadJ3P5EaeJ1Zy2pDNER64BXDbcQU8VE/119/image.jpg"
    },
    {
      "id": "ec_8c1e6ffb65bceb2c369aab8c",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019d4f39-3c6f-7161-8d58-4c3eee118422.webp",
      "image_media": {
        "alt_text": "Playground with slide and swings, surrounded by green grass and trees, with apartment buildings in the background.",
        "public_id": "019d4f39-3c6f-7161-8d58-4c3eee118422",
        "storage_key": "property/6767906449162935/019d4f39-3c6f-7161-8d58-4c3eee118422.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our community playground, featuring a slide and swings, perfect for residents of all ages.",
      "link": "false",
      "alt_text": "Playground with slide and swings, surrounded by green grass and trees, with apartment buildings in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/QiBfWFDx2Jbb3L7sj6VDJUEOQ0X74yzQbexQhVHyYGk/104/image.jpg"
    },
    {
      "id": "ec_96ed9dc0956ef7ca5963ed33",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfdde-f668-717a-8482-bd5586d5290c.webp",
      "image_media": {
        "alt_text": "Aerial view of an apartment complex courtyard featuring a basketball court and swimming pool.",
        "public_id": "019cfdde-f668-717a-8482-bd5586d5290c",
        "storage_key": "property/6767906449162935/019cfdde-f668-717a-8482-bd5586d5290c.webp",
        "width": 2000,
        "height": 1498
      },
      "title": "Community",
      "description": "Enjoy active living with our outdoor basketball court and refreshing swimming pool. Perfect for recreation and relaxation.",
      "link": "false",
      "alt_text": "Aerial view of an apartment complex courtyard featuring a basketball court and swimming pool.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/a2YT5xspjs1otZyTChhbJmMF5SJhus0p4v345LrveaI/118/image.jpg"
    },
    {
      "id": "ec_6dd06c07b39527df6300b730",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfddf-0099-717f-8c0b-b316562ea05e.webp",
      "image_media": {
        "alt_text": "A beautifully decorated bedroom with a king-size bed, blue curtains, and decorative pillows.",
        "public_id": "019cfddf-0099-717f-8c0b-b316562ea05e",
        "storage_key": "property/6767906449162935/019cfddf-0099-717f-8c0b-b316562ea05e.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Experience ultimate comfort in this beautifully decorated bedroom. Featuring a king-size bed, plush bedding, and elegant decor, it's the perfect sanctuary for rest and relaxation.",
      "link": "false",
      "alt_text": "A beautifully decorated bedroom with a king-size bed, blue curtains, and decorative pillows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/joW3n4NBDMfmz9uSblVPlml3RUuUmGM2TQyHitEhULk/102/image.jpg"
    },
    {
      "id": "ec_f4e4f6322d3c01502ebc0330",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfddf-0176-73ff-ba4e-b9feb882d425.webp",
      "image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "019cfddf-0176-73ff-ba4e-b9feb882d425",
        "storage_key": "property/6767906449162935/019cfddf-0176-73ff-ba4e-b9feb882d425.webp",
        "width": 2000,
        "height": 1498
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling swimming pool, featuring comfortable lounge chairs and lush palm trees. Perfect for soaking up the sun or taking a refreshing dip.",
      "link": "false",
      "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and palm trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/QjSyZeViMDy5jHX9GmDyNf9nwJ2Z1PTpvHYkmQ_WvpE/118/image.jpg"
    },
    {
      "id": "ec_f4e755278655a679b3248d80",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfddf-0288-7732-85cc-995eac66cc9a.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, sink, toilet, and bathtub.",
        "public_id": "019cfddf-0288-7732-85cc-995eac66cc9a",
        "storage_key": "property/6767906449162935/019cfddf-0288-7732-85cc-995eac66cc9a.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Modern bathroom featuring a granite countertop vanity with a single sink, toilet, and a bathtub with a tiled shower surround. Decorated with contemporary art and vases.",
      "link": "false",
      "alt_text": "Bathroom with vanity, sink, toilet, and bathtub.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/N4qdr_pllbv8fzURs956IrEhUIItylthCejM7asEvTs/102/image.jpg"
    },
    {
      "id": "ec_9ad1cc071bab18842550e656",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfddf-0460-77f9-a82c-68a275693c0c.webp",
      "image_media": {
        "alt_text": "Beach volleyball court with net, surrounded by green grass and trees. A building is visible in the background.",
        "public_id": "019cfddf-0460-77f9-a82c-68a275693c0c",
        "storage_key": "property/6767906449162935/019cfddf-0460-77f9-a82c-68a275693c0c.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy a friendly game of beach volleyball on our on-site court. Perfect for staying active and socializing with neighbors.",
      "link": "false",
      "alt_text": "Beach volleyball court with net, surrounded by green grass and trees. A building is visible in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/HrXB1wXiE-gxDstZJceu7_ss58MS4vrRXDGAxq4_r5Y/119/image.jpg"
    },
    {
      "id": "ec_f0f9548bec79556bcce3ce4e",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfddf-0d6e-727c-8bda-ce8e3bd3e297.webp",
      "image_media": {
        "alt_text": "Coffee and water station with cups, coffee maker, and sink in a community area.",
        "public_id": "019cfddf-0d6e-727c-8bda-ce8e3bd3e297",
        "storage_key": "property/6767906449162935/019cfddf-0d6e-727c-8bda-ce8e3bd3e297.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Enjoy complimentary coffee and water at our convenient station, perfect for a quick refreshment.",
      "link": "false",
      "alt_text": "Coffee and water station with cups, coffee maker, and sink in a community area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/mG1CjV66aJ8jjZ9I6HMh4TdYVKC251JbOdY9_7Ae1EU/102/image.jpg"
    },
    {
      "id": "ec_987ad66af9ce8f836fdc2d54",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfddf-0cd1-72ba-8dc2-50b08a976e12.webp",
      "image_media": {
        "alt_text": "Dining area with a round table and four orange chairs, modern art on the wall.",
        "public_id": "019cfddf-0cd1-72ba-8dc2-50b08a976e12",
        "storage_key": "property/6767906449162935/019cfddf-0cd1-72ba-8dc2-50b08a976e12.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Cozy dining area featuring a round table, four plush orange chairs, and abstract art. Enjoy your meals in style and comfort.",
      "link": "false",
      "alt_text": "Dining area with a round table and four orange chairs, modern art on the wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/Z7an2QrMoQN67zI51I6HIscBsJl1JcotlR8TYLYiF0c/119/image.jpg"
    },
    {
      "id": "ec_db9153a598981ddaf0683a9e",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfddf-1197-751b-9785-c22bf4bfedb0.webp",
      "image_media": {
        "alt_text": "Gym with cardio machines, weight racks, and free weights.",
        "public_id": "019cfddf-1197-751b-9785-c22bf4bfedb0",
        "storage_key": "property/6767906449162935/019cfddf-1197-751b-9785-c22bf4bfedb0.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Fully equipped fitness center with cardio machines, weight racks, and free weights, offering residents a convenient place to exercise.",
      "link": "false",
      "alt_text": "Gym with cardio machines, weight racks, and free weights.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/8REvd6G6dFeqx3B2I4FYh0xA8HKBZFKf1jS5A5DFeis/102/image.jpg"
    },
    {
      "id": "ec_fc6c5097d0dd000d98bb2be1",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfddf-14a1-7017-b0d9-83ef846a0fa9.webp",
      "image_media": {
        "alt_text": "Living room with a white sofa, blue accent chairs, a coffee table, and a TV.",
        "public_id": "019cfddf-14a1-7017-b0d9-83ef846a0fa9",
        "storage_key": "property/6767906449162935/019cfddf-14a1-7017-b0d9-83ef846a0fa9.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a plush white sofa, accent chairs, a modern coffee table, and a wall-mounted TV, perfect for relaxation and entertaining.",
      "link": "false",
      "alt_text": "Living room with a white sofa, blue accent chairs, a coffee table, and a TV.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/jiWar8IsEN1LuKlvhq3SKE0tSF--eWzemsohkiCm_8o/119/image.jpg"
    },
    {
      "id": "ec_5d799fdd4cd5fb1d49de5165",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfddf-18db-73ef-90a4-a1ed04e4b5f5.webp",
      "image_media": {
        "alt_text": "Aerial view of a swimming pool area with lounge chairs and umbrellas.",
        "public_id": "019cfddf-18db-73ef-90a4-a1ed04e4b5f5",
        "storage_key": "property/6767906449162935/019cfddf-18db-73ef-90a4-a1ed04e4b5f5.webp",
        "width": 2000,
        "height": 1498
      },
      "title": "Community",
      "description": "Relax and unwind by the sparkling swimming pool, surrounded by comfortable lounge chairs and shaded umbrellas. Perfect for a sunny day!",
      "link": "false",
      "alt_text": "Aerial view of a swimming pool area with lounge chairs and umbrellas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/LidtbXtnUXSiXBxdZWB3WOn4TnapzC_2rc11F52em8s/102/image.jpg"
    },
    {
      "id": "ec_aa9ebba64e5660af1bcc4b55",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfddf-1a51-71fd-a174-d89fe906719c.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with shelves and hangers.",
        "public_id": "019cfddf-1a51-71fd-a174-d89fe906719c",
        "storage_key": "property/6767906449162935/019cfddf-1a51-71fd-a174-d89fe906719c.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet with ample shelving and hanging space, ready for your storage needs.",
      "link": "false",
      "alt_text": "Empty walk-in closet with shelves and hangers.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/DMEXTzAI2VkKA-nEx2CY7Qr-LzZuvBI4AITpyweHqeg/119/image.jpg"
    },
    {
      "id": "ec_578617b413f75babe1e2d415",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfddf-20b2-764e-bdb0-e7290af2285a.webp",
      "image_media": {
        "alt_text": "Living room with sofa, armchair, coffee table, and TV.",
        "public_id": "019cfddf-20b2-764e-bdb0-e7290af2285a",
        "storage_key": "property/6767906449162935/019cfddf-20b2-764e-bdb0-e7290af2285a.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Enjoy a comfortable and stylish living space with modern furnishings and decor. Perfect for relaxing or entertaining guests.",
      "link": "false",
      "alt_text": "Living room with sofa, armchair, coffee table, and TV.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/P-JJ4MzioMOkGkh-2_AKh7Iqw4C6sDiylHBRityu_VI/102/image.jpg"
    },
    {
      "id": "ec_ced6c04495c5100bc7b1533e",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfddf-20bd-772f-8562-8681217682c8.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment complex with pool and surrounding neighborhood.",
        "public_id": "019cfddf-20bd-772f-8562-8681217682c8",
        "storage_key": "property/6767906449162935/019cfddf-20bd-772f-8562-8681217682c8.webp",
        "width": 2000,
        "height": 1498
      },
      "title": "Community",
      "description": "Expansive aerial view showcasing the apartment complex, its amenities including a swimming pool, and the surrounding suburban landscape.",
      "link": "false",
      "alt_text": "Aerial view of apartment complex with pool and surrounding neighborhood.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/uAUCt4pihyfxIKFJDLaOn605UGPi1V-S6ctQpg6uFGY/119/image.jpg"
    },
    {
      "id": "ec_cf4951289320ff70273466e3",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfddf-26a2-748d-b045-97ef3fbab076.webp",
      "image_media": {
        "alt_text": "Exterior of apartment buildings with brick facades and balconies.",
        "public_id": "019cfddf-26a2-748d-b045-97ef3fbab076",
        "storage_key": "property/6767906449162935/019cfddf-26a2-748d-b045-97ef3fbab076.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Charming apartment buildings with brick exteriors, balconies, and manicured landscaping. Ample parking is available.",
      "link": "false",
      "alt_text": "Exterior of apartment buildings with brick facades and balconies.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/Vqtk07wi7Gd7hezJWX0AkQXmMgFA2sQA5mdVEHvqePc/102/image.jpg"
    },
    {
      "id": "ec_eeee963ad7c91c7b1be64f3d",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfddf-28b4-752c-b1e5-73d87866bd62.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with brick and siding, outdoor staircases, and a parked car.",
        "public_id": "019cfddf-28b4-752c-b1e5-73d87866bd62",
        "storage_key": "property/6767906449162935/019cfddf-28b4-752c-b1e5-73d87866bd62.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "An exterior view of a multi-story apartment building featuring a combination of brick and siding, with visible staircases and a car parked in the lot. This image showcases the building's architecture and common areas.",
      "link": "false",
      "alt_text": "Exterior view of apartment building with brick and siding, outdoor staircases, and a parked car.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/Gs-TUaE45vTsKUrIW_ENeyrzN_8CagNMiXNBKgUuwoo/119/image.jpg"
    },
    {
      "id": "ec_7a2b739228b0891ee2d71a28",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019d4f39-62c9-772b-938b-5f74fd1ca43b.webp",
      "image_media": {
        "alt_text": "The Lynx apartment complex monument sign.",
        "public_id": "019d4f39-62c9-772b-938b-5f74fd1ca43b",
        "storage_key": "property/6767906449162935/019d4f39-62c9-772b-938b-5f74fd1ca43b.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Welcome to The Lynx, a premier apartment community offering comfortable living spaces and convenient amenities. This monument sign welcomes residents and guests.",
      "link": "false",
      "alt_text": "The Lynx apartment complex monument sign.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/p5afR4lEa8ms9r9x3rrBtAVW8SDWPT_sFKEvuSboqcM/104/image.jpg"
    },
    {
      "id": "ec_0f2d9db0dae1404c57729f8f",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfddf-2fb7-72ce-aadc-bc96f2bb9a4b.webp",
      "image_media": {
        "alt_text": "Stylish living room with modern furniture and large screen TV.",
        "public_id": "019cfddf-2fb7-72ce-aadc-bc96f2bb9a4b",
        "storage_key": "property/6767906449162935/019cfddf-2fb7-72ce-aadc-bc96f2bb9a4b.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this beautifully appointed living room, featuring contemporary furnishings and a large entertainment system.",
      "link": "false",
      "alt_text": "Stylish living room with modern furniture and large screen TV.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/cvurZRpK9aIay_KM0FtF-1Uv4xzl-EPfz5QsdKg8tgs/102/image.jpg"
    },
    {
      "id": "ec_b07488d8bf75748222ab75d2",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfddf-3682-73c9-afe0-db2023459ce4.webp",
      "image_media": {
        "alt_text": "Coffee and snack bar with a Keurig machine, sink, and mini-fridges.",
        "public_id": "019cfddf-3682-73c9-afe0-db2023459ce4",
        "storage_key": "property/6767906449162935/019cfddf-3682-73c9-afe0-db2023459ce4.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy complimentary coffee and snacks at our convenient coffee bar, featuring a Keurig machine and ample space for refreshments.",
      "link": "false",
      "alt_text": "Coffee and snack bar with a Keurig machine, sink, and mini-fridges.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/jr7zJWLf2kMWI5iyFbI2ZNn-bSrchif1hy2Urt-q9aY/118/image.jpg"
    },
    {
      "id": "ec_5edcb61bdf484f928d06f598",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfddf-35d6-7669-97ad-774f5236209a.webp",
      "image_media": {
        "alt_text": "A modern gym with cardio machines, weight racks, and a tire flip.",
        "public_id": "019cfddf-35d6-7669-97ad-774f5236209a",
        "storage_key": "property/6767906449162935/019cfddf-35d6-7669-97ad-774f5236209a.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, featuring cardio equipment, weight training stations, and functional fitness tools.",
      "link": "false",
      "alt_text": "A modern gym with cardio machines, weight racks, and a tire flip.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/erCXMIIiMWSYimOAzyHEQ30oB3zJIzv2IuSHqqPjs-8/118/image.jpg"
    },
    {
      "id": "ec_7c5249a4e2159ec208634b7a",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfddf-3b06-73da-8541-bb31e1f1577e.webp",
      "image_media": {
        "alt_text": "Spin bikes in a modern gym with large mirrors and windows overlooking the pool.",
        "public_id": "019cfddf-3b06-73da-8541-bb31e1f1577e",
        "storage_key": "property/6767906449162935/019cfddf-3b06-73da-8541-bb31e1f1577e.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Get your workout in at our state-of-the-art fitness center, featuring a variety of cardio equipment and expansive mirrors.",
      "link": "false",
      "alt_text": "Spin bikes in a modern gym with large mirrors and windows overlooking the pool.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/CqcYNI-e2oqsKEM_t85T5myD6mEVR3TZJzrVbJQWoCE/119/image.jpg"
    },
    {
      "id": "ec_eed6f3debba90f4a52ac6f16",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfddf-4168-7548-8d78-ab8820b2e33a.webp",
      "image_media": {
        "alt_text": "Aerial view of a sparkling blue swimming pool with lounge chairs and tables surrounding it.",
        "public_id": "019cfddf-4168-7548-8d78-ab8820b2e33a",
        "storage_key": "property/6767906449162935/019cfddf-4168-7548-8d78-ab8820b2e33a.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our beautiful outdoor swimming pool, surrounded by comfortable lounge chairs and shaded seating areas. Perfect for relaxing and soaking up the sun.",
      "link": "false",
      "alt_text": "Aerial view of a sparkling blue swimming pool with lounge chairs and tables surrounding it.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/WdV2Iw7Dueth2XSdGEujdXHemdPNnkqm1-biZ3CoZWc/118/image.jpg"
    },
    {
      "id": "ec_a00b09fb0a312d2ed98d8b21",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019d4f39-ef40-7290-9b55-ca76f920ac04.webp",
      "image_media": {
        "alt_text": "Apartment complex swimming pool with lounge chairs and tables.",
        "public_id": "019d4f39-ef40-7290-9b55-ca76f920ac04",
        "storage_key": "property/6767906449162935/019d4f39-ef40-7290-9b55-ca76f920ac04.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in the sparkling blue pool, surrounded by lush greenery and comfortable seating. Perfect for relaxing and soaking up the sun.",
      "link": "false",
      "alt_text": "Apartment complex swimming pool with lounge chairs and tables.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/hxrPtsry1jJmnjBO0mmm45JElVkpWfjfqqgVnb2ahos/102/image.jpg"
    },
    {
      "id": "ec_e01635a12841f6b907ab748d",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfddf-444b-77d6-b63a-30d6ca24737a.webp",
      "image_media": {
        "alt_text": "Apartment complex with outdoor basketball court and swimming pool.",
        "public_id": "019cfddf-444b-77d6-b63a-30d6ca24737a",
        "storage_key": "property/6767906449162935/019cfddf-444b-77d6-b63a-30d6ca24737a.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy an active lifestyle with our outdoor basketball court and sparkling swimming pool. Perfect for recreation and relaxation.",
      "link": "false",
      "alt_text": "Apartment complex with outdoor basketball court and swimming pool.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/0V2ZekvGKypUSqe30PZEeD-R6wZ_vGR86zosQ80QqRg/113/image.jpg"
    },
    {
      "id": "ec_1066c371bfe2935520dd2761",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfddf-467c-75ac-ba72-400b99ca97bf.webp",
      "image_media": {
        "alt_text": "Laundry room with washers and dryers, some open.",
        "public_id": "019cfddf-467c-75ac-ba72-400b99ca97bf",
        "storage_key": "property/6767906449162935/019cfddf-467c-75ac-ba72-400b99ca97bf.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "On-site laundry facilities with multiple washing machines and dryers available for resident use.",
      "link": "false",
      "alt_text": "Laundry room with washers and dryers, some open.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/hhLF6wncr6z7Uem1LVxuoyp1Z9Rcdq7oeUreaAZPXGs/118/image.jpg"
    },
    {
      "id": "ec_63f63d757c65f71bcc093598",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019d4f39-78ef-7798-83bb-95e1ed973a0f.webp",
      "image_media": {
        "alt_text": "Mailboxes for apartment residents",
        "public_id": "019d4f39-78ef-7798-83bb-95e1ed973a0f",
        "storage_key": "property/6767906449162935/019d4f39-78ef-7798-83bb-95e1ed973a0f.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Secure mailboxes for residents at our apartment community.",
      "link": "false",
      "alt_text": "Mailboxes for apartment residents",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/wQnUCpaqu4_9UfY53ef5yqVKO69dN_gIuQs4fD3Cjj4/104/image.jpg"
    },
    {
      "id": "ec_a80145feb749da1000b559c8",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfddf-505c-73f4-8535-a5c0e559444a.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings with parking lot and surrounding green spaces.",
        "public_id": "019cfddf-505c-73f4-8535-a5c0e559444a",
        "storage_key": "property/6767906449162935/019cfddf-505c-73f4-8535-a5c0e559444a.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Discover comfortable living in our apartment community, featuring spacious grounds and convenient parking. Enjoy the scenic surroundings and tranquil atmosphere.",
      "link": "false",
      "alt_text": "Aerial view of apartment buildings with parking lot and surrounding green spaces.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/lqmCyaS9NZ3zycDWRG0_DXjB7sfcvu9nbSl0XBUvKEA/119/image.jpg"
    },
    {
      "id": "ec_5da2719b708a353e484b79ca",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfddf-5071-71e5-875c-f254b9ae1d8a.webp",
      "image_media": {
        "alt_text": "Living room and dining area with modern furniture and decor",
        "public_id": "019cfddf-5071-71e5-875c-f254b9ae1d8a",
        "storage_key": "property/6767906449162935/019cfddf-5071-71e5-875c-f254b9ae1d8a.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Stylish living and dining area featuring a comfortable sofa, accent chairs, and a chic dining set. Perfect for entertaining and relaxation.",
      "link": "false",
      "alt_text": "Living room and dining area with modern furniture and decor",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/jxtB7-Rev0OwXQLUp2drycFi7EcNCdQZM3vg0j7bsJI/102/image.jpg"
    },
    {
      "id": "ec_96e099fd7507722863dc74c7",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfddf-558e-70a3-ac1c-9f7991dc3068.webp",
      "image_media": {
        "alt_text": "Kitchen with granite countertops, stainless steel appliances, and modern cabinets.",
        "public_id": "019cfddf-558e-70a3-ac1c-9f7991dc3068",
        "storage_key": "property/6767906449162935/019cfddf-558e-70a3-ac1c-9f7991dc3068.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring granite countertops, stainless steel appliances including a refrigerator and stove, and ample cabinet space.",
      "link": "false",
      "alt_text": "Kitchen with granite countertops, stainless steel appliances, and modern cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/Z8lZ0xu4g51kkSsjvkPBA5cLmmQ1am4FFQTP2D3iCyQ/119/image.jpg"
    },
    {
      "id": "ec_4612d23f6e49570ec6437b44",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfddf-571c-746e-aa81-74e26d24a02a.webp",
      "image_media": {
        "alt_text": "Master bedroom with a king-size bed, bedside tables with lamps, and blue curtains.",
        "public_id": "019cfddf-571c-746e-aa81-74e26d24a02a",
        "storage_key": "property/6767906449162935/019cfddf-571c-746e-aa81-74e26d24a02a.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious master bedroom featuring a comfortable king-size bed, elegant bedside tables with lamps, and large windows dressed with blue curtains.",
      "link": "false",
      "alt_text": "Master bedroom with a king-size bed, bedside tables with lamps, and blue curtains.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/rVULWau0w0XfG8LMZfLFJdPp7SMLUVMpGbea66TaAiU/102/image.jpg"
    },
    {
      "id": "ec_e5bc4ef50a0f51caa89d6548",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfddf-59a6-73f9-933c-cebe98850afc.webp",
      "image_media": {
        "alt_text": "Bathroom with granite countertop vanity, sink, mirror, toilet, and bathtub with shower curtain.",
        "public_id": "019cfddf-59a6-73f9-933c-cebe98850afc",
        "storage_key": "property/6767906449162935/019cfddf-59a6-73f9-933c-cebe98850afc.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "A beautifully appointed bathroom featuring a granite countertop vanity, modern sink, and elegant mirror, alongside a toilet and a bathtub with a decorative shower curtain.",
      "link": "false",
      "alt_text": "Bathroom with granite countertop vanity, sink, mirror, toilet, and bathtub with shower curtain.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/yywrDpERXXlwUaGj4ZCZkVspGo0r3M5udU-zd799NOM/119/image.jpg"
    },
    {
      "id": "ec_97731c20ab29d97f60d5b1de",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfddf-5cc9-71ec-8b78-27169035ccae.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a queen bed, a desk with a blue chair, and decorative mirrors.",
        "public_id": "019cfddf-5cc9-71ec-8b78-27169035ccae",
        "storage_key": "property/6767906449162935/019cfddf-5cc9-71ec-8b78-27169035ccae.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Relax in this beautifully appointed bedroom featuring a plush queen-size bed, a stylish desk area, and elegant mirrored decor. Perfect for unwinding.",
      "link": "false",
      "alt_text": "Cozy bedroom with a queen bed, a desk with a blue chair, and decorative mirrors.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/p1Aj8BpD8plwz3_2kRbyxpuhEsA9czCV_fsZDwvOtRc/102/image.jpg"
    },
    {
      "id": "ec_10984c798e3786f7a0d53d0c",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfddf-6248-768d-add0-d087b236bb20.webp",
      "image_media": {
        "alt_text": "Modern bathroom with granite countertop, white vanity, and tiled shower.",
        "public_id": "019cfddf-6248-768d-add0-d087b236bb20",
        "storage_key": "property/6767906449162935/019cfddf-6248-768d-add0-d087b236bb20.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this beautifully appointed apartment bathroom, featuring a spacious vanity with granite countertops and a tiled shower-tub combination.",
      "link": "false",
      "alt_text": "Modern bathroom with granite countertop, white vanity, and tiled shower.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/o-bdizkj-5yqkK5F_J93ZFtLjdGdgAdmtonNXk_bv2Y/119/image.jpg"
    },
    {
      "id": "ec_7c0226f03f4a72b004e0b6a2",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfddf-64a6-764a-89cf-7d17bdadbfcf.webp",
      "image_media": {
        "alt_text": "Living room with a blue sectional sofa, accent chair, coffee table, and TV console.",
        "public_id": "019cfddf-64a6-764a-89cf-7d17bdadbfcf",
        "storage_key": "property/6767906449162935/019cfddf-64a6-764a-89cf-7d17bdadbfcf.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Relax in this beautifully appointed living room, featuring a plush blue sectional sofa, comfortable accent chair, and modern entertainment console.",
      "link": "false",
      "alt_text": "Living room with a blue sectional sofa, accent chair, coffee table, and TV console.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/egfE19XcWd80NFXmca3l1v9wtLqPHqkdaw7mz7oE904/102/image.jpg"
    },
    {
      "id": "ec_4681c50efc55185bfcd5c4e5",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfddf-6748-70e6-bbe4-01a3c91062cf.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and abstract art.",
        "public_id": "019cfddf-6748-70e6-bbe4-01a3c91062cf",
        "storage_key": "property/6767906449162935/019cfddf-6748-70e6-bbe4-01a3c91062cf.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "A stylish and functional kitchen featuring sleek white cabinetry, elegant granite countertops, and modern stainless steel appliances, perfect for any home chef.",
      "link": "false",
      "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and abstract art.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/mfS1tHxkLEa5ZfL4uBXFf7ky_4-mxxLkjJBCt87ZJao/119/image.jpg"
    },
    {
      "id": "ec_ab4f7f6377540e2d56c43819",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019d4f39-af46-75db-9915-21f856a434b3.webp",
      "image_media": {
        "alt_text": "Modern dining area with marble table and velvet chairs.",
        "public_id": "019d4f39-af46-75db-9915-21f856a434b3",
        "storage_key": "property/6767906449162935/019d4f39-af46-75db-9915-21f856a434b3.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Stylish dining nook featuring a marble-topped table, plush velvet chairs, and decorative shelves, perfect for intimate meals.",
      "link": "false",
      "alt_text": "Modern dining area with marble table and velvet chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/2M6KZSMPiKw3Nmy5uPMPI7X6jBs29Dlns22l1Hay0lc/102/image.jpg"
    },
    {
      "id": "ec_6c607fb87ad0e8bc8d6e7d49",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfddf-6d01-7114-8e23-edcdd293b562.webp",
      "image_media": {
        "alt_text": "View of a queen-size bed with white bedding and decorative pillows in a bedroom. A closet and a bathroom are visible.",
        "public_id": "019cfddf-6d01-7114-8e23-edcdd293b562",
        "storage_key": "property/6767906449162935/019cfddf-6d01-7114-8e23-edcdd293b562.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Step into comfort in this beautifully appointed bedroom, featuring a queen-size bed, ample closet space, and an en-suite bathroom. Perfect for relaxation and rest.",
      "link": "false",
      "alt_text": "View of a queen-size bed with white bedding and decorative pillows in a bedroom. A closet and a bathroom are visible.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/bGnqSIkbN2EgopB3QkQNbbwVVLyi6d0kYvYIpoWRalU/119/image.jpg"
    },
    {
      "id": "ec_b1b47fd5a9b96114528b5277",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfddf-74da-70cd-8fe3-b16b6b62fdaf.webp",
      "image_media": {
        "alt_text": "Bathroom with bathtub, toilet, and vanity with granite countertop.",
        "public_id": "019cfddf-74da-70cd-8fe3-b16b6b62fdaf",
        "storage_key": "property/6767906449162935/019cfddf-74da-70cd-8fe3-b16b6b62fdaf.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "A clean and modern bathroom featuring a bathtub with a navy blue shower curtain, a white toilet, and a vanity with a granite countertop and stainless steel fixtures.",
      "link": "false",
      "alt_text": "Bathroom with bathtub, toilet, and vanity with granite countertop.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/pLpazPXezvSjTURrhT6cgGKCIvUyQkuZCTAeDERBIUo/102/image.jpg"
    },
    {
      "id": "ec_814cfa3c697ea0e762bc7398",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019d4f39-b82f-70ef-8f50-cbaa548685b8.webp",
      "image_media": {
        "alt_text": "Apartment building with outdoor swimming pool and lounge chairs",
        "public_id": "019d4f39-b82f-70ef-8f50-cbaa548685b8",
        "storage_key": "property/6767906449162935/019d4f39-b82f-70ef-8f50-cbaa548685b8.webp",
        "width": 1280,
        "height": 370
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor pool, complete with comfortable lounge chairs for soaking up the sun. A perfect spot for unwinding and enjoying the beautiful weather.",
      "link": "false",
      "alt_text": "Apartment building with outdoor swimming pool and lounge chairs",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/t5ClJB1RSY1BBb_zGRxwJfD3i3wF-y4QWusjOWwniBg/102/image.jpg"
    },
    {
      "id": "ec_b1c387b3fd3ce2b9e6b7dc02",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfddf-767a-73a2-a420-b1d7d4a2804f.webp",
      "image_media": {
        "alt_text": "Kitchen with white appliances, gray countertops, and a fruit bowl.",
        "public_id": "019cfddf-767a-73a2-a420-b1d7d4a2804f",
        "storage_key": "property/6767906449162935/019cfddf-767a-73a2-a420-b1d7d4a2804f.webp",
        "width": 640,
        "height": 560
      },
      "title": "Apartment",
      "description": "A bright and functional kitchen featuring white appliances, ample counter space, and decorative touches.",
      "link": "false",
      "alt_text": "Kitchen with white appliances, gray countertops, and a fruit bowl.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/l5zxy4U3pvKFGmxw1K49pXXwciRr2hm8iWcdkKU3WS0/102/image.jpg"
    },
    {
      "id": "ec_f80969be5afdf14583173b52",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019d4f39-ea3b-779c-af65-1fc6637088c3.webp",
      "image_media": {
        "alt_text": "The Lynx apartment complex outdoor swimming pool area with lounge chairs and umbrellas.",
        "public_id": "019d4f39-ea3b-779c-af65-1fc6637088c3",
        "storage_key": "property/6767906449162935/019d4f39-ea3b-779c-af65-1fc6637088c3.webp",
        "width": 762,
        "height": 125
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor swimming pool at The Lynx, complete with comfortable lounge chairs and lush landscaping.",
      "link": "false",
      "alt_text": "The Lynx apartment complex outdoor swimming pool area with lounge chairs and umbrellas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/sLmqOU3HJsSbbnR5dlieJgdL-0lBqvkSjByIvisLcPU/102/image.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_e24ca5a7f3f065a4f97fd41b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "poi_name": "Royal Ridge Elementary School",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "false",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_27a1e43c531b942f099ead7f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "poi_name": "Saint Mary's Hall",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "false",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [],
  "reviews": [
    {
      "id": "ec_9e794043f665fc8989f52e78",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "rating": "4",
      "name": "false",
      "text": "The apartments I'm staying at is great in alot of ways the rent is reasonable the front office is very quick to handle anything wrong with the apartment, and the 24 hour help center always answers, some things that bother me is the the gates are always getting stuck or damaged there is a minor bug issue, other than that it's quite peaceful no one bothers you an I haven't had any car damage issues or break ins with in my area, it's Convenient for drive back an forth for work an has alot of resources around the apartments!",
      "date": "false",
      "title": "my place"
    },
    {
      "id": "ec_0461d56aa1d52f0921f5714d",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "rating": "4",
      "name": "false",
      "text": "It very nice to live. There a lot of different types of apartments and they have some very good specials. It is in good area of San Antonio. The manager is very nice and they try to do repairs as possible. There is a lot of apartments. The rents are very good and the apartment are in good shape.",
      "date": "false",
      "title": "Amber ton Apartments"
    },
    {
      "id": "ec_6687568f5758730aa857837a",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "rating": "4",
      "name": "false",
      "text": "Moved into Amberton almost 2 months ago. It's a very quiet complex, and all the neighbors we've met are pleasant. Staff is easy to work with and maintenance requests are handled swiftly. At least in the newer phase of the apartments, amenities are modern-enough, and accessibility for a wheelchair user is ample. The grounds are well upkept, outside of some mechanical problems with the entry gate at the back of the complex. All in all, I would recommend it for anyone looking for an older, or more military-centric, crowd to live around.",
      "date": "false",
      "title": "A great place to live"
    },
    {
      "id": "ec_1a861d5dac224ecd83f7b8d0",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "rating": "5",
      "name": "false",
      "text": "it's a nice quiet neighborhood. everyone keeps to themselves. some people need to slow down then driving in the apartments but other than that I enjoy living here.",
      "date": "false",
      "title": "quiet neighborhood"
    },
    {
      "id": "ec_46c91241f70586982935a69b",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "rating": "5",
      "name": "false",
      "text": "Yes agreed! High crime area with police running thru the premises. The management was involved in a shooting that took place here in broad day light with children everywhere. There is only one good pool that is always getting vandalized. The gates are always broken. No security; except for the police who are constantly called. Only one good laundromat. There is no actual spa and their fitness center is closet sized and no equipment works because of vandalizing that occurred over 4 months ago. The apartments closest to the office all smell like cat urine and that’s probably because they allow stray cats and state they offer an adoption program for them. The actual office has cats inside as well. The mailboxes are constantly being broken into and large packages are not allowed to be left at the office and when left at your door they will be stolen. Maintenance WILL enter your apartment without consent or at least they did in my situation.",
      "date": "false",
      "title": "This place is a nightmare"
    },
    {
      "id": "ec_496ed13473e7aeb79ee1b70c",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "rating": "5",
      "name": "false",
      "text": "Loved it lived there for 2 years never had a problem ??",
      "date": "false",
      "title": "Amberton "
    },
    {
      "id": "ec_bd0900228f66334036f6e77c",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "rating": "5",
      "name": "false",
      "text": "First of all the staff at The Amberton are really very helpful and take care of us residents! Maintenance requests are performed quickly. Pools and grounds Always clean. I highly recommend this place.",
      "date": "false",
      "title": "Amberton apartments community"
    },
    {
      "id": "ec_40a4b2d4624839d52a09efa4",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "rating": "5",
      "name": "false",
      "text": "Lovely apartments. Very clean. Friendly and helpful staff.",
      "date": "false",
      "title": "Beautiful Apartments!"
    },
    {
      "id": "ec_90e7b313d3f80cb6df847f3c",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "rating": "5",
      "name": "false",
      "text": "It's Really beautiful apartment, the renovation very nice and the most important is the leasing stuff, they are very friendly and helpful.   ",
      "date": "false",
      "title": "Beautiful Apartments!"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_a311684f0be39ea8dedae4cc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "Virtual Tour 1",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://vapi.apartments.com/video/play/7t2k1a?source=180"
    },
    {
      "id": "ec_7660524f4cc8a6e64f609025",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "2BR, 2BA - 911SF.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfddf-a473-713f-aafc-ee004cfdcfc7.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern living room with stylish furniture and decor.",
        "public_id": "019cfddf-a473-713f-aafc-ee004cfdcfc7",
        "storage_key": "property/6767906449162935/019cfddf-a473-713f-aafc-ee004cfdcfc7.webp",
        "width": 800,
        "height": 449
      },
      "virtual_tour_title": "2BR, 2BA - 911SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=44TzP4SKQMd"
    },
    {
      "id": "ec_cdc46d3afadc200272e0e204",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "1BR, 1BA - 500SF.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfddf-a41f-76a8-bd3d-eb70417eb42f.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern dining and living room with a sectional sofa, coffee table, and dining table with chairs.",
        "public_id": "019cfddf-a41f-76a8-bd3d-eb70417eb42f",
        "storage_key": "property/6767906449162935/019cfddf-a41f-76a8-bd3d-eb70417eb42f.webp",
        "width": 2048,
        "height": 1152
      },
      "virtual_tour_title": "1BR, 1BA - 500SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=H4Hf5mYxEth"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019faf32-d2e7-769f-9813-b547f68f2062",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "The Lynx Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162935"
    }
  ],
  "hyperlocal_queries": [],
  "custom_fields": [
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 1"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Rise"
    }
  ],
  "custom_rollout_phase": "Phase 1",
  "custom_vibesites_theme": "Rise"
};

export const generatedAt = '2026-08-18T17:29:05.352Z';
